import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from "gatsby";
import { OutboundLink } from "gatsby-plugin-gtag";
import { EuiSpacer } from "@elastic/eui";
import NavButtons from "components/Outdoor_Cameras/IN-9820_QFHD/NavButtons";
import CompareOutdoor from "components/Products/Compare/CompareOutdoorFlyout";
import SmartCards from "components/Products/Flyouts/Cards/9408Cards";
import BreadCrumbs from "components/Layout/BreadCrumbs";
import SEOHelmet from "components/Layout/SEOHelmet";
export const _frontmatter = {
  "title": "IN-9820 4K (QFHD)",
  "path": "/Aussenkameras/IN-9820_QFHD/",
  "dateChanged": "2022-10-08",
  "author": "Mike Polinowski",
  "excerpt": "Die IN-9820 4K (QFHD) ist die erste INSTAR IP-Überwachungskamera für den Außenbereich, die unseren neuen Sony 2160p / QFHD STARVIS Sensor verwendet.",
  "image": "../P_SearchThumb_IN-9820QFHD.png",
  "social": "/images/Search/P_SearchThumb_IN-9820QFHD.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_P-IN-9008HD_white.webp",
  "chapter": "Outdoor Cameras"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title="IN-9820 4K (QFHD)" dateChanged="2017-12-12" author="Mike Polinowski" tag="INSTAR IP Camera" description="Die IN-9820 4K (QFHD) ist die erste INSTAR IP-Überwachungskamera für den Außenbereich, die unseren neuen Sony 2160p / QFHD STARVIS Sensor verwendet." image="/images/Search/P_SearchThumb_IN-9420HD.png" twitter="/images/Search/P_SearchThumb_IN-9420HD.webp" location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN="/en/Outdoor_Cameras/IN-9820_QFHD/" locationFR="/fr/Outdoor_Cameras/IN-9820_QFHD/" crumbLabel="IN-9420" mdxType="BreadCrumbs" />
    <NavButtons mdxType="NavButtons" />
    <h1 {...{
      "id": "in-9820-4k-qfhd",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#in-9820-4k-qfhd",
        "aria-label": "in 9820 4k qfhd permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`IN-9820 4K (QFHD)`}</h1>
    <CompareOutdoor mdxType="CompareOutdoor" />
    <h2 {...{
      "id": "produktübersicht",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#produkt%C3%BCbersicht",
        "aria-label": "produktübersicht permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Produktübersicht`}</h2>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/af179e6e2de1d7da5dd017cb70ad6154/573d3/IN-9820_QFHD_Overview_width1650.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "50.43478260869565%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABiklEQVQoz2WSWWvbQBSF8/+hFPpQ+tK3UvpaWgqFQKEEk8UKjuqklmU5dm1rsywv0TLa5gujIFeKD4gR9x4+zr0zZ1JK1KdUSUmeF+RFUf+/1F96jUedQmSkQhDHCUma0kj1ztpmIQTrYMN0tsAPtmzCHeF214EpFUXOcrnEnDyS5/mxVwPbCcPQw/U8RiMT7VZnZfs4roeUVQcYxxG+b2M7PkGwOQUqqehRPYLA89Zot3fcaHe4ClhVx7HUSg5PMWUp2e0PWNaMKIpPRz48RZSVrIG24zE2LR7+jnEc71W6hDgRFGVJuN0znc7x/XUXqOS6PvqfIesg5N9ihWFMKIryOEobqOtDJtYjwWbLyDBZrZz/wMY4my8Y6EPG5pS+NsC23c5lHIFJwuW1VvtvtAHD+xH7/eEUqPb3/sNHPn3+Qu+qX+9HIjsJG++v3z3evH3Hj5/nGKaFyPIusDFeXfe56F1y/2CQZVknXds3my/5+u17nVStpz1J5x0qlWXZeaiv1a6lqTipPwPIJf5seZDc7gAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/af179e6e2de1d7da5dd017cb70ad6154/e4706/IN-9820_QFHD_Overview_width1650.avif 230w", "/de/static/af179e6e2de1d7da5dd017cb70ad6154/d1af7/IN-9820_QFHD_Overview_width1650.avif 460w", "/de/static/af179e6e2de1d7da5dd017cb70ad6154/7f308/IN-9820_QFHD_Overview_width1650.avif 920w", "/de/static/af179e6e2de1d7da5dd017cb70ad6154/e1c99/IN-9820_QFHD_Overview_width1650.avif 1380w", "/de/static/af179e6e2de1d7da5dd017cb70ad6154/e02f7/IN-9820_QFHD_Overview_width1650.avif 1650w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/af179e6e2de1d7da5dd017cb70ad6154/a0b58/IN-9820_QFHD_Overview_width1650.webp 230w", "/de/static/af179e6e2de1d7da5dd017cb70ad6154/bc10c/IN-9820_QFHD_Overview_width1650.webp 460w", "/de/static/af179e6e2de1d7da5dd017cb70ad6154/966d8/IN-9820_QFHD_Overview_width1650.webp 920w", "/de/static/af179e6e2de1d7da5dd017cb70ad6154/445df/IN-9820_QFHD_Overview_width1650.webp 1380w", "/de/static/af179e6e2de1d7da5dd017cb70ad6154/44758/IN-9820_QFHD_Overview_width1650.webp 1650w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/af179e6e2de1d7da5dd017cb70ad6154/81c8e/IN-9820_QFHD_Overview_width1650.png 230w", "/de/static/af179e6e2de1d7da5dd017cb70ad6154/08a84/IN-9820_QFHD_Overview_width1650.png 460w", "/de/static/af179e6e2de1d7da5dd017cb70ad6154/c0255/IN-9820_QFHD_Overview_width1650.png 920w", "/de/static/af179e6e2de1d7da5dd017cb70ad6154/b1001/IN-9820_QFHD_Overview_width1650.png 1380w", "/de/static/af179e6e2de1d7da5dd017cb70ad6154/573d3/IN-9820_QFHD_Overview_width1650.png 1650w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/af179e6e2de1d7da5dd017cb70ad6154/c0255/IN-9820_QFHD_Overview_width1650.png",
              "alt": "INSTAR IN-9820 4K (QFHD)",
              "title": "INSTAR IN-9820 4K (QFHD)",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <p>{`Die IN-9820 4K (QFHD) ist eine wetterfeste und drahtlose Außenkamera. Eingebaute Hochleistungs-Infrarotdioden ermöglichen es Ihnen, tief in der Dunkelheit zu sehen. Der integrierte IR-Sperrfilter wiederum ermöglicht die Aufnahme von nativen Farben am Tag, wie sie das menschliche Auge sieht. Der effiziente h.265-Kompressionscodec ermöglicht die Aufzeichnung von Alarmvideos auf einer internen `}<Link to="/Bewegungserkennung/SD_Karten_Zugriff/" mdxType="Link">{`SD-Speicherkarte`}</Link>{` mit vergleichsweise geringer Dateigröße bei bester Videoqualität.`}</p>
    <p>{`Die IN-9820 4K (QFHD)-Überwachungskamera ist bereit für die Implementierung in bestehende Sicherheitssysteme. Mit Hilfe des praktischen Onvif-Protokolls ist die Integration nur ein paar Knopfdrücke entfernt. Aber auch als eigenständiges Gerät bietet sie Ihnen eine Reihe von Alarmfunktionen wie `}<Link to="/Bewegungserkennung/Alarm_Benachrichtigung/" mdxType="Link">{`Email & Push Notification`}</Link>{`, Zwei-Wege-Kommunikation und eine Alarmsirene. Mit der WPS-Funktion können Sie die Kamera mit einem Tastendruck mit Ihrem WiFi-Netzwerk verbinden. Der Zugriff auf Ihre Kamera über das Internet ist noch einfacher. Die Punkt-2-Punkt-Verbindung kann durch Scannen eines QR-Codes mit unserer Smartphone-App hergestellt werden. Die kostenlose `}<strong parentName="p">{`InstarVision`}</strong>{` Mobile App ist verfügbar für `}<a parentName="p" {...{
        "href": "/de/Software/Android/InstarVision/"
      }}>{`Android`}</a>{`, `}<a parentName="p" {...{
        "href": "/de/Software/iOS/InstarVision/"
      }}>{`iOS`}</a>{`, `}<a parentName="p" {...{
        "href": "/de/Software/Windows/InstarVision/Metro/"
      }}>{`Windows Metro`}</a>{` und `}<a parentName="p" {...{
        "href": "/de/Software/Windows/InstarVision/Windows_Phone/"
      }}>{`Windows Phone`}</a>{`.`}</p>
    <p>{`Die Empfindlichkeit des integrierten Panasonic `}<strong parentName="p">{`Pyroelektrischen Sensors`}</strong>{` wurde dank eines einzigartigen Spaltdesigns der pyroelektrischen Elemente deutlich verbessert. Die getrennten Sensorbereiche verhindern ein thermisches Übersprechen zwischen den einzelnen Sensorelementen. Dies ermöglicht eine zuverlässige Erkennung, selbst wenn der Temperaturunterschied zwischen dem Hintergrund (z. B. Boden/Wand) und dem Zielobjekt (menschlicher Körper, Automotor usw.) gering ist (etwa 4 °C).`}</p>
    <h3 {...{
      "id": "hardware",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#hardware",
        "aria-label": "hardware permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Hardware`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`STARVIS`}</strong><code parentName="li" {...{
          "className": "language-text"
        }}>{`*`}</code>{` 2k+ (WQHD) 2160p CMOS-Sensor / Auflösung 3840 x 2160px`}</li>
      <li parentName="ul">{`5-fach Zoom Autofokus Objektiv: 2,7mm - 13.5mm ( 30 ~ 130º diagonal)`}</li>
      <li parentName="ul">{`Dual LEDs 6 - Hochleistung IR LEDs (@ 850nm) und 6 Hochleistung Weißlicht LEDs`}</li>
      <li parentName="ul">{`Power-over-Ethernet (PoE) IEEE 802.3at`}</li>
      <li parentName="ul">{`SD Karte max. 1TB (32GB incl.) für Alarm- und manuelle Aufnahme (15 Sek)`}</li>
      <li parentName="ul">{`Integrierter Panasonic Pyroelektrischer Sensor - PIR Reichweite bis zu 12m`}</li>
      <li parentName="ul">{`Integriertes Mikrofon und Lautsprecher`}</li>
      <li parentName="ul">{`Eingebauter Alarmein-/Ausgang für externes Alarm-Zubehör`}</li>
    </ul>
    <h3 {...{
      "id": "netzwerk",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#netzwerk",
        "aria-label": "netzwerk permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Netzwerk`}</h3>
    <ul>
      <li parentName="ul">{`RJ-45-Ethernet-Anschluss für eine einfache Integration in Ihr 100-Mbit-Heimnetzwerk`}</li>
      <li parentName="ul">{`DHCP- und UPnP-Unterstützung für eine automatische Netzwerkintegration`}</li>
      <li parentName="ul">{`Integrierte persönliche, kostenlose `}<Link to="/Fernzugriff/Der_DDNS_Dienst/" mdxType="Link">{`DDNS ("Internet") Adresse`}</Link>{` für den Zugriff auf Ihre Kamera über das Internet`}</li>
      <li parentName="ul">{`Kostenfreier Point-2-Point-Zugriff mit InstarVision, unterstüzt IPv6`}</li>
      <li parentName="ul">{`Opt. Speicherung / Verwaltung der Alarmvideos in der INSTAR Cloud`}</li>
      <li parentName="ul">{`Übertragung von Alarmbildern / Videos per FTP(S) / sFTP`}</li>
      <li parentName="ul">{`Wi-Fi Protected Setup (WPS) zur einfachen `}<Link to="/Schnell_Installation/Herstellen_der_WLAN_Verbindung/" mdxType="Link">{`WLAN-Einrichtung`}</Link></li>
      <li parentName="ul">{`2,4Ghz / 5Ghz WLAN, Wi-Fi 5, 802.11ac, 866 Mbit/s und WPA2 / WPA3 / Enterprise-Verschlüsselung`}</li>
      <li parentName="ul">{`Zugriff auf die WebUI über HTTPS mit TLS-Verschlüsselung`}</li>
    </ul>
    <h3 {...{
      "id": "software",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#software",
        "aria-label": "software permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Software`}</h3>
    <ul>
      <li parentName="ul">{`Kostenlose `}<a parentName="li" {...{
          "href": "/de/Software/Android/"
        }}>{`Android`}</a>{`, `}<a parentName="li" {...{
          "href": "/de/Software/iOS/"
        }}>{`iPhone`}</a>{` und `}<a parentName="li" {...{
          "href": "/de/Software/Windows/"
        }}>{`Windows Phone`}</a>{` App`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/de/Web_User_Interface/1440p_Serie/"
        }}>{`Web-Benutzeroberfläche`}</a>{` ermöglicht
eine einfache Konfiguration und Kamerasteuerung über Ihren Standard-Webbrowser
(Chrome, Safari, Firefox, Internet Explorer)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/de/Web_User_Interface/1440p_Serie/System/Benutzer/"
        }}>{`Verwaltung mehrerer Benutzer`}</a>{` und gleichzeitige Anmeldung für 3 Benutzer`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/de/Web_User_Interface/1440p_Serie/Alarm/Bereiche/"
        }}>{`Software-basierte Bewegung`}</a>{` und `}<a parentName="li" {...{
          "href": "/de/Web_User_Interface/1440p_Serie/Alarm/Aktionen/"
        }}>{`Audio`}</a>{` Erkennung und `}<a parentName="li" {...{
          "href": "/de/Bewegungserkennung/Alarm_Benachrichtigung/"
        }}>{`E-Mail-Benachrichtigung`}</a>{` mit angehängten Schnappschüssen`}</li>
      <li parentName="ul">{`Aufzeichnung von 15s-60s Alarmvideos (+ 3s-10s Voraufzeichnung) direkt auf eine `}<Link to="/Bewegungserkennung/SD_Karten_Zugriff/" mdxType="Link">{`interne SD-Karte`}</Link></li>
      <li parentName="ul">{`Privatsphäre - Blenden Sie bis zu vier Bereiche im Video aus`}</li>
      <li parentName="ul">{`Alarmbereiche - Bis zu vier Bereiche für eine softwareseitige Bewegungserkennung`}</li>
      <li parentName="ul">{`Alarmauslöser für Bewegungs-, Wärme-, Objekt- und Geräuscherkennung`}</li>
      <li parentName="ul">{`Pre-Recording - Es wird bereits drei Sekunden “vor” dem Alarmevent aufgenommen`}</li>
      <li parentName="ul">{`Videoaufnahme 15 Sek. Alarmvideos sowie manuelle Aufnahme auf MicroSD`}</li>
      <li parentName="ul">{`Mitteilungen Bei Alarm erhalten Sie Emails und/oder Push-Mitteilungen`}</li>
      <li parentName="ul">{`Smart IoT Smarthome Einbindung per Alarmserver, MQTT(S) und HTTP(S) API`}</li>
      <li parentName="ul">{`Videostream Unterstützt Protokolle wie RTSP, HTTP (HTML5), ONVIF, MJPEG...`}</li>
      <li parentName="ul">{`Fotoserie Bilder per Zeitintervall / Webseiten-Integration / Zeitrafferaufnahmen`}</li>
      <li parentName="ul">{`Gegensprechen Zwei-Wege-Audiokommunikation mit unserer App InstarVision`}</li>
      <li parentName="ul">{`Optischer Zoom Optisches 4-fach Zoomobjektiv mit Autofokus`}</li>
    </ul>
    <EuiSpacer mdxType="EuiSpacer" />
    <SmartCards mdxType="SmartCards" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "bildqualität",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bildqualit%C3%A4t",
        "aria-label": "bildqualität permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bildqualität`}</h3>
    <p>{`Sicherheitskameras müssen in der Lage sein, in einer Vielzahl von Umgebungen klare Bilder aufzuzeichnen. Die `}<strong parentName="p">{`STARVIS`}</strong><code parentName="p" {...{
        "className": "language-text"
      }}>{`*`}</code>{`-Bildsensoren von Sony erfüllen diese Anforderung, indem sie eine hohe Empfindlichkeit bieten, die für Aufnahmen bei schwachem Licht und bei Nacht geeignet ist. `}<strong parentName="p">{`STARVIS`}</strong><code parentName="p" {...{
        "className": "language-text"
      }}>{`*`}</code>{` ist eine Technologie mit hintergrundbeleuchteten Pixeln, die in CMOS-Bildsensoren für Sicherheitskameraanwendungen eingesetzt wird. Sie zeichnet sich durch hochempfindliche, hintergrundbeleuchtete Sensorpixel aus und ermöglicht eine hohe Bildqualität im Bereich des sichtbaren Lichts und des nahen Infrarotlichts. Der IMX415 `}<strong parentName="p">{`STARVIS`}</strong><code parentName="p" {...{
        "className": "language-text"
      }}>{`*`}</code>{`-Sensor ist ein diagonaler 2,8-Zoll-CMOS-Solid-State-Bildsensor mit aktiven Pixeln, einer quadratischen Pixelanordnung und 8.29 Mio. effektiven Pixeln.`}</p>
    <h3 {...{
      "id": "vergleich-der-auflösungen",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#vergleich-der-aufl%C3%B6sungen",
        "aria-label": "vergleich der auflösungen permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Vergleich der Auflösungen`}</h3>
    <p>{`Viele integrierte Funktionen ermöglichen es Ihnen, diese Kamera nicht nur für die Überwachung, sondern auch für Ihre persönlichen Projekte zu nutzen. Die `}<Link to="/Bewegungserkennung/Alarm_FTP_Upload/" mdxType="Link">{`FTP-Unterstützung`}</Link>{` ermöglicht es Ihnen beispielsweise, die IN-9820 4K (QFHD) als multifunktionale Outdoor-Webcam für die `}<Link to="/Erweitert/Webseiten_Einbindung/" mdxType="Link">{`Integration auf Ihrer Website`}</Link>{` zu nutzen - zum Beispiel als Wettercam.`}</p>
    <p>{`Der SONY `}<strong parentName="p">{`STARVIS`}</strong><code parentName="p" {...{
        "className": "language-text"
      }}>{`*`}</code>{` IMX415 CMOS-Sensor verfügt über einen Dynamikbereich von bis zu 72 dB, fortschrittliche HDR-Funktionen und digitales Overlap-HDR verbessern die Bildqualität und das Kontrastverhalten weiter und ermöglichen eine detailliertere Bildanalyse. In Kombination mit dem geringen Dunkelstrom verbessern diese Funktionen die Leistung der Kamera bei Anwendungen, die einen hohen Dynamikbereich erfordern, weiter.`}</p>
    <ul>
      <li parentName="ul"><code parentName="li" {...{
          "className": "language-text"
        }}>{`*`}</code>{` `}<strong parentName="li">{`STARVIS`}</strong>{` ist ein Warenzeichen der Sony Corporation. Ein STARVIS-Sensor ist definiert durch eine Empfindlichkeit von `}<em parentName="li">{`2000 mV`}</em>{` oder mehr pro `}<em parentName="li">{`1 μm²`}</em>{` bei Beleuchtung mit einer `}<em parentName="li">{`706 cd/m²`}</em>{` Lichtquelle, `}<em parentName="li">{`F5.6`}</em>{` in `}<em parentName="li">{`1s`}</em>{` Akkumulationsäquivalent.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      